import { ComponentRef, EmbeddedViewRef } from '@angular/core';
/**
 * Dom or Native Element 工具类
 * 
 * @author fbchen
 * @version 1.0 2017-05-19
 */
export class DomUtils {
/**
 * 判断是否<code>root</code>结点是否包含<code>n</code>结点
 * 
 * @param {?} root 根结点Element
 * @param {?} n 待判断的结点
 * @return {?}
 */
static contains(root: HTMLElement, n: Node): boolean {
        let /** @type {?} */ node: Node = n;
        while (node) {
            if (node === root) {
                return true;
            }
            node = node.parentNode;
        }

        return false;
    }
/**
 * Gets the root HTMLElement for an instantiated component.
 * 
 * @param {?} componentRef 组件引用对象
 * @return {?}
 */
static getComponentRootNode(componentRef: ComponentRef<any>): HTMLElement {
        return /** @type {?} */(( ( /** @type {?} */((componentRef.hostView as EmbeddedViewRef<any>))).rootNodes[0] as HTMLElement));
    }
/**
 * 检测两个结点是否直接的父子关系
 * 
 * @param {?} parent 父结点
 * @param {?} child 子结点
 * @return {?}
 */
static isParentChild(parent: HTMLElement, child: HTMLElement): boolean {
        return parent && child && child.parentElement === parent;
    }

}
